const _ = require('lodash');
const moment = require('moment');
const { LOGIC_TEXT } = require('./constant')

const operators = {
  eq: (a, b) => a == b, // had to do simple comparison since we are saving integer values as strings. Same for the next line
  not: (a, b) => a != b,
  lt: (a, b) => a < b,
  lte: (a, b) => a <= b,
  gt: (a, b) => a > b,
  gte: (a, b) => a >= b,
  btw: (a, b, c) => a >= b && a <= c,
  nbtw: (a, b, c) => a < b || a > c,
};

const binaryOperators = ['eq', 'not', 'lt', 'lte', 'gt', 'gte'];
const ternaryOperators = ['btw', 'nbtw'];

const takePhotoOperators = {
  eq: (a) => a?.length,
  not: (a) => !a?.length,
};

const dropdownOperators = {
  eq: (a, b) => a?.includes(b),
  not: (a, b) => !a?.includes(b)
};

const textOperators = {
  eq: (a, b) => a?.toLowerCase() === b?.toLowerCase(),
  not: (a, b) => a?.toLowerCase() !== b?.toLowerCase(),
};

const dateTimeOperators = {
  eq: (a, b) => moment(a).isSame(b),
  not: (a, b) => !moment(a).isSame(b),
  lt: (a, b) => moment(a).isBefore(b),
  lte: (a, b) => moment(a).isSameOrBefore(b),
  gt: (a, b) => moment(a).isAfter(b),
  gte: (a, b) => moment(a).isSameOrAfter(b),
};


const formatNumberValue = (value, field) => {
  return Array.isArray(value)
      ? `${field.type === 'cost' ? field.unit : ''}${value[0]}${
          field.type !== 'cost' ? field.unit : ''
      } and ${field.type === 'cost' ? field.unit : ''}${value[1]}${
          field.type !== 'cost' ? field.unit : ''
      }`
      : `${field.type === 'cost' ? field.unit : ''}${value}${
          field.type !== 'cost' ? field.unit : ''
      }`;
};

const getValueText = (value, field) => {
  switch (field?.type) {
    case 'multipleChoice':
    case 'dropdown': {
      const answerOption = field?.options?.find((op) => op.id === value);

      return answerOption ? answerOption.label : '';
    }
    case 'passFail': {
      const answerOption = field.options.find((op) => op.value === value);
      return answerOption ? answerOption.label : '';
    }
    case 'textField': {
      return value || '';
    }
    case 'procedure':
      return 'checked';
    case 'number':
    case 'temperature':
    case 'cost':
      return formatNumberValue(value, field);
  }
};

const mapActions = (automation) => {
  return automation.actions.map((action) => ({
    ...action,
    automationId: automation.id,
  }));
};

const validateItemAutomations = ({ answer, itemType, automations }) => {
  const actionsToTrigger = [];
  _.each(automations, (automation) => {
    const condition = _.first(automation.conditions);
    switch (itemType) {
      case 'takePhoto':
        if (takePhotoOperators[condition.logic](answer)) {
          actionsToTrigger.push(...mapActions(automation));
        }
        break;
      case 'procedure':
        if (operators[condition.logic](answer, Boolean(condition.value))) {
          actionsToTrigger.push(...mapActions(automation));
        }
        break;
      case 'textField':
        if (textOperators[condition.logic](answer, condition.value)) {
          actionsToTrigger.push(...mapActions(automation));
        }
        break;
      case 'number':
      case 'cost':
      case 'temperature':
        if (
          _.includes(binaryOperators, condition.logic) &&
          operators[condition.logic](Number(answer), Number(condition.value))
        ) {
          actionsToTrigger.push(...mapActions(automation));
        } else if (
          _.includes(ternaryOperators, condition.logic) &&
          operators[condition.logic](
            Number(answer),
            Number(_.first(condition.value)),
            Number(_.last(condition.value))
          )
        ) {
          actionsToTrigger.push(...mapActions(automation));
        }
        break;
      case 'dateTime':
        if (dateTimeOperators[condition.logic](answer, condition.value)) {
          actionsToTrigger.push(...mapActions(automation));
        }
        break;

      case 'dropdown':
        if (dropdownOperators[condition.logic](answer, condition.value)) {
          actionsToTrigger.push(...mapActions(automation));
        }
        break;
      default:
        if (operators[condition.logic](answer, condition.value)) {
          actionsToTrigger.push(...mapActions(automation));
        }
        break;
    }
  });
  return actionsToTrigger;
};

const getAutomationString = (field, automation) => {
  if (!automation || !field) return '';

  const [action] = automation.actions || [];
  const [condition] = automation.conditions || [];

  if (!action || !condition) return '';

  const conditionText = LOGIC_TEXT[condition.logic];
  const valueText = getValueText(condition.value, field);

  const str = `If answer ${conditionText} ${valueText} then ${_.lowerCase(action.type)}`;

  return str;
};


module.exports = {
  validateItemAutomations,
  getAutomationString,
};
